import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center h-screen bg-gray-100" }


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFound',
  emits: ['is-page-loaded'],
  setup(__props, { emit: __emit }) {

    const emit = __emit;
    emit('is-page-loaded', true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "text-center" }, [
      _createElementVNode("h1", { class: "text-6xl font-bold text-gray-800 mb-4" }, "404"),
      _createElementVNode("h2", { class: "text-2xl font-semibold text-gray-700 mb-4" }, "Page Not Found"),
      _createElementVNode("p", { class: "text-lg text-gray-600" }, "The page you are looking for does not exist.")
    ], -1)
  ])))
}
}

})